<div class="page-container">
  <div>
    <div class="header">
      <div>
        <h1><a href="/">Мой День</a></h1>
        <h2>
          <button on:click={previousDay}>&larr;</button>
          {selectedWeekDay}, {selectedDay}
          <button on:click={nextDay}>&rarr;</button>
        </h2>
      </div>
      <button on:click={downloadDB}>&darr; Выгрузить базу данных</button>
    </div>

    {#each baseStructure as block, blockIndex}
      <h2>{block.title} ({block.tasksDone} из {block.tasksTotal})</h2>
      <ul>
        {#each block.tasks as task, taskIndex}
          <Task
            {task}
            canEdit={canEditTasks}
            {isEarlierDate}
            isYesterday={selectedDay === yesterday}
            on:change={onCheckboxClicked}
            toggleRepeatable={() => toggleRepeatable(codes[blockIndex], taskIndex)}
            moveTask={() => moveTask(codes[blockIndex], taskIndex)}
            removeTask={() => removeTask(codes[blockIndex], taskIndex)}
            disabled={today !== selectedDay}
          />
        {/each}
        {#if canEditTasks}
          <input
            type="text"
            on:change={(e) => addTask(e, codes[blockIndex])}
            placeholder={getNewTaskPlaceholder(codes[blockIndex])}
          >
        {/if}
      </ul>
    {/each}

    {#if isEarlierDate}
      <hr>
      <h2>
        Всего задач выполено:
        {baseStructure.map(block => block.tasksDone).reduce((amount, sum) => sum + amount, 0)}
        из
        {baseStructure.map(block => block.tasksTotal).reduce((amount, sum) => sum + amount, 0)}
      </h2>
    {/if}
  </div>

  <div>
    <ul class="breadcrumps">
      <li>
        <span>
          Автор —{' '}
          <a href="https://polyakovin.ru" target="_blank" rel="noreferrer">
            Игорь Поляков
          </a>
        </span>
      </li>
      <!-- <li><a href="https://trello.com/b/73AgvZrl/%D0%BC%D0%BE%D0%B9-%D0%B4%D0%B5%D0%BD%D1%8C" target="_blank">Trello</a></li>
      <li><a href="https://github.com/polyakovin/my-day" target="_blank">GitHub</a></li> -->
    </ul>
  </div>
</div>


<script>
  import { assocPath, path } from 'ramda';
	import { Block, formatDate, isFirstDateEarlier } from './helpers.js';
  import Task from './Task.svelte';
  import newTaskPlaceholders from './data/newTaskPlaceholders.js';

  const codes = ['work', 'life', 'reward'];
  const weekDays = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
  const weekDaysShort = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  const oneDay = 1000 * 60 * 60 * 24;
  const now = new Date();
  const today = formatDate(now);
  const yesterday = formatDate(new Date(+now - oneDay));
  const jsonData = localStorage.getItem('data');
  const defaultData = {
    [formatDate(now)]: {
      work: [{ title: 'Запланировать рабочие дела на завтра' }],
      life: [
        { title: 'Запланировать личные дела на завтра' },
        { title: 'Запланировать награды на завтра' },
      ],
      reward: [],
    },
  };
  let selectedDate = now;
  let data = jsonData ? JSON.parse(localStorage.getItem('data')) : defaultData;
  console.log(data);
  $: selectedWeekDay = weekDaysShort[selectedDate.getDay()];
  $: selectedDay = formatDate(selectedDate);
  $: isEarlierDate = isFirstDateEarlier(selectedDay, today);
  $: canEditTasks = !isEarlierDate && (now.getHours() < 11 || today !== selectedDay);
  $: selectedDayTasks = data[selectedDay] || {};
  $: baseStructure = [
    new Block('Рабочие обязательства', selectedDayTasks['work']),
    new Block('Личные обязательства перед самим собой', selectedDayTasks['life']),
    new Block('Награды', selectedDayTasks['reward']),
  ];
  const getNewTaskPlaceholder = (code) => newTaskPlaceholders[code][Math.floor(Math.random() * newTaskPlaceholders[code].length)];

  cloneRepeatableTasks();

  function cloneRepeatableTasks() {
    if (path([today, 'meta', 'hasClonedRepeatableTasks'], data) || !data[yesterday]) {
      return;
    }
    let hasChanges = false;
    for (const code of codes) {
      for (const task of (data[yesterday][code] || [])) {
        if (task.isRepeatable) {
          if (!data[today]) {
            data[today] = {};
          }
          if (!data[today][code]) {
            data[today][code] = [];
          }
          data[today][code].push({
            ...task,
            title: task.isDone ? task.title.replace(/\d+/, n => ++n) : task.title,
            isDone: false,
          });
          hasChanges = true;
        }
      }
    }
    if (!hasChanges) {
      return;
    }
    data = assocPath([today, 'meta', 'hasClonedRepeatableTasks'], true, data);
    saveData();
  }


  function onCheckboxClicked() {
    baseStructure = [...baseStructure];
    saveData();
  }

  function getJsonData() {
    return JSON.stringify(data);
  }

  function saveData() {
    localStorage.setItem('data', getJsonData());
  }

  function previousDay() {
    selectedDate = new Date(+selectedDate - oneDay);
  }

  function nextDay() {
    selectedDate = new Date(+selectedDate + oneDay);
  }

  function addTask(event, taskBlockCode) {
    const title = event.target.value;
    if (!data[selectedDay]) {
      data[selectedDay] = {};
    }
    if (!data[selectedDay][taskBlockCode]) {
      data[selectedDay][taskBlockCode] = [];
    }
    data[selectedDay][taskBlockCode].push({ title });
    data = data;
    event.target.value = '';
    saveData();
  }

  function toggleRepeatable(taskBlockCode, taskIndex) {
    data[selectedDay][taskBlockCode][taskIndex].isRepeatable ^= true;
    data = data;
    saveData();
  }

  function moveTask(taskBlockCode, taskIndex) {
    const nextDay = formatDate(new Date(+selectedDate + oneDay));
    const isEarlierDate = isFirstDateEarlier(selectedDay, today);
    const dayToMoveTo = isEarlierDate ? today : nextDay;
    const taskToMove = data[selectedDay][taskBlockCode][taskIndex];
    path([dayToMoveTo, taskBlockCode], data)
      ? data[dayToMoveTo][taskBlockCode].push(taskToMove)
      : data = assocPath([dayToMoveTo, taskBlockCode], [taskToMove], data);
    if (!isEarlierDate) {
      removeTask(taskBlockCode, taskIndex);
    } else {
      alert('Дубликат создан. Он уже в сегодняшнем списке задач.')
    }
    data = data;
    saveData();
  }

  function removeTask(taskBlockCode, taskIndex) {
    data[selectedDay][taskBlockCode].splice(taskIndex, 1);
    data = data;
    saveData();
  }

  function downloadDB() {
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', `data:text/json;charset=utf-8,${encodeURIComponent(getJsonData())}`);
    downloadAnchorNode.setAttribute('download', `myDayDB_${today}.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }
</script>


<style>
  .page-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding-left: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .header > button {
    margin: 10px;
  }

  .header h1, .header h2 {
    display: inline-block;
  }

  h1 {
    margin-top: 0;
    margin-right: 30px;
  }

  h1 a {
    color: black;
  }
  h1 a:hover {
    text-decoration: none;
  }

  h2 {
    margin-top: 10px;
    margin-bottom: 0;
  }

  h2 button {
    background: none;
    border: none;
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin-top: 7px;
  }

  .breadcrumps {
    text-align: right;
    font-size: 1.2rem;
    margin-right: 15px;
  }

  .breadcrumps li {
    display: inline-block;
    margin-right: 10px;
  }

  .breadcrumps li,
  .breadcrumps li a {
    color: gray;
  }

  .breadcrumps li a {
    text-decoration: underline;
  }

  input {
    width: 500px;
    margin-left: 10px;
  }
</style>
